import React, { useContext } from "react"
import { PresetContext } from "Components/Preset/context"
import Add from "./add"
import Update from "./update"

export default () => {
    const { presetModal } = useContext(PresetContext)
    if (presetModal) {
        switch (presetModal.type) {
            case "add":
                return <Add />
            case "update":
                return <Update />
            default:
                return null
        }
    } else {
        return null
    }
}

